<template>
  <div>
    <h4><b-icon icon="check-all" />Aprobaciones</h4>
    <div v-if="!approvals">
      <b-icon class="orange" icon="info-circle" />Este documento no ha pasado
      por un flujo de aprobación.
    </div>
    <div
      v-show="approvals && approvals.length > 0"
      class="aprobaciones"
      v-for="(approver, index) in approvals"
      v-bind:key="index"
    >
      <div class="numero">{{ index + 1 }}</div>
      <div class="nombre">
        <span v-if="approver.personas && approver.personas.length > 0">Grupo:</span>
        {{ approver.nombre }}
        <div class="d-flex align-items-center">
          <ApprovalsIcons :item="approver"/>
          <span class="ml-2 accion-aprobador">{{ approver.accion }}</span>
        </div>
      </div>
      <div class="correo">{{ approver.correo }}</div>
      <div v-if="approver.personas">
        <div
          v-for="(person, index) in approver.personas"
          v-bind:key="index"
          v-show="person.accion === 'Aprobado' || person.accion === 'Rechazado'"
          class="persona"
          :title="person.fecha"
        >
          <div class="content">
            <ApprovalsIcons :item="person"/>
          </div>
          <div class="d-inline-block">{{ person.nombre }}</div>
          <div class="correo-persona">{{ person.correo }}</div>
        </div>
      </div>
      <div class="fecha" v-if="approver.fecha">
        {{ approver.fecha.replace(" ", " a las ") }} hrs.
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import ApprovalsIcons from './ApprovalsIcons';

export default {
  name: 'Approvals',
  props: ['approvals'],
  components: {
    ApprovalsIcons
  }
};
</script>

<style scoped>
.orange {
  color: orange;
}
.accion-aprobador {
  font-size: 70%;
  color: #666;
  font-weight: 100;
}
.content {
  display: contents;
}
.correo-persona {
  font-size: 11px;
  color: gray;
}
.clear {
  clear: both;
}
.fecha {
  float: right;
  font-size: 80%;
  color: #333;
}
</style>
